import React from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';

const DEFAULT_OBJECT = {};

const DocumentTemplateStamp = (props) => {
  let {
    field,
    editMode,
    pageWidth,
    pageHeight,
    selectEditElement,
    updateField,
    handleStop,
    onChange,
    prefill = DEFAULT_OBJECT,
    selectedEditElement,
  } = props;
  let {
    x_percent,
    y_percent,
    w_percent,
    h_percent,
    style,
    id,
    rotation = 360,
    scale = 1.0,
    opacity = 0.8,
  } = field;

  style = DocumentTemplateUtils.parseStyle(style || {}) || {};

  const isSelected = selectedEditElement === id;

  let wrapperClassName = 'input-wrapper';
  if (isSelected) wrapperClassName += ' edit';

  let stamp = (
    <div className={wrapperClassName}>
      <div
        name={id}
        key={id}
        data-field-id={id}
        className="template-field"
        onChange={onChange}
        style={{
          position: 'absolute',
          width: 'max-content',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '10px double var(--color-border-default)',
          borderRadius: '15px',
          padding: '5px',
          boxSizing: 'border-box',
          fontFamily: 'Courier New',
          fontWeight: 'bold',
          fontSize: '14px',
          zIndex: 1,
          background: `rgba(255,255,255, ${opacity})`,
          userSelect: 'none',
          ...style,
          transform: `scale(${scale}) rotate(${rotation}deg)`,
        }}
      >
        <span>{prefill.patient_name}</span>
        <span>
          DoB: {prefill.patient_birthdate}, Gender: {prefill.patient_gender}
        </span>
        {prefill.patient_ohip_number && <span>OHIP# {prefill.patient_ohip_number}</span>}
        <span>Phone: {prefill.patient_phone}</span>
        <span>Address: {prefill.patient_address_line1_2}</span>
        <span>
          {prefill.patient_address_postcode}, {prefill.patient_address_city}
        </span>
      </div>
    </div>
  );

  let x = DocumentTemplateUtils.percentToPixel(x_percent, pageWidth);
  let y = DocumentTemplateUtils.percentToPixel(y_percent, pageHeight);
  let w = DocumentTemplateUtils.percentToPixel(w_percent, pageWidth);
  let h = DocumentTemplateUtils.percentToPixel(h_percent, pageHeight);
  return DocumentTemplateUtils.getRndElement(
    id,
    stamp,
    { x, y, w, h },
    editMode,
    selectEditElement,
    handleStop,
    updateField,
  );
};

DocumentTemplateStamp.propTypes = {
  field: PropTypes.object,
  editMode: PropTypes.bool,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
  updateField: PropTypes.func,
};

export default DocumentTemplateStamp;
